/* eslint-disable react/prop-types */
import React from 'react'
import { useMutation } from 'react-query'
import { useGlobalSnackbarStore } from '../../store/GlobalSnackBarStore'
import { LoadingButton } from '@mui/lab'
import { FileDownloadRounded } from '@mui/icons-material'
import { AccountsClient } from '../../interactors/clients/AccountsClient'
import { useAccountsStore } from '../../store/AccountsStore'
import { MenuItem, Stack, Tooltip, Typography } from '@mui/material'
import { AccountDtoPermission } from '../../interactors/gen/backendClient'

interface Props {
  menuItem?: boolean
  onBeforeOpen?: () => void
}

export const MemberExportSheet: React.FC<Props> = ({ menuItem = false, onBeforeOpen }) => {
  const globalSnackbarStore = useGlobalSnackbarStore()
  const accountsStore = useAccountsStore()
  const isReader =
    accountsStore.connectedAccount?.permission === AccountDtoPermission.Read ||
    accountsStore.connectedAccount?.permission === AccountDtoPermission.Editor

  const customer = accountsStore.connectedCustomer

  const exportExcelMutation = useMutation(AccountsClient.downloadMembersExcel, {
    onSuccess: async () => {
      globalSnackbarStore.triggerSuccessMessage(`Excel téléchargé !`)
    },
    onError: async (error) => {
      console.error(error)
      globalSnackbarStore.triggerErrorMessage(`Une erreur est survenue !`)
    },
  })
  const handleExport = () => {
    onBeforeOpen?.()
    exportExcelMutation.mutate(customer?.name || 'Association')
  }

  return (
    <Tooltip
      title={
        !accountsStore.isSubscribed()
          ? 'Cette fonctionnalité est réservée aux abonnés payants'
          : isReader
          ? `Votre permission ne vous permet pas d'effectuer un export. Rapprochez vous d'un admin`
          : ''
      }
    >
      {menuItem ? (
        <span>
          <MenuItem onClick={handleExport} disabled={!accountsStore.isSubscribed() || isReader}>
            <Stack direction="row" alignItems="center" spacing={1.25}>
              <FileDownloadRounded fontSize="small" />
              <Typography>Export</Typography>
            </Stack>
          </MenuItem>
        </span>
      ) : (
        <span>
          <LoadingButton
            color="primary"
            variant="contained"
            onClick={handleExport}
            loading={exportExcelMutation.isLoading}
            disabled={!accountsStore.isSubscribed() || isReader}
            sx={{ marginTop: 4, paddingX: 3 }}
          >
            Exporter
          </LoadingButton>
        </span>
      )}
    </Tooltip>
  )
}
